import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Mail, MapPin } from "lucide-react";
import { BRAND, LOGO_URL, CATEGORIES } from "@/lib/brand";

export default function Footer() {
  const igUrl = `https://instagram.com/${BRAND.instagram}`;
  return (
    <footer className="bg-sj-ink text-white" data-testid="footer">
      <div className="mx-auto max-w-[1440px] px-5 sm:px-10 py-20 grid grid-cols-1 md:grid-cols-3 gap-12">
        <div>
          <div className="flex items-center gap-3">
            <img src={LOGO_URL} alt="" className="h-16 w-16 sm:h-20 sm:w-20 object-contain" />
            <div>
              <div className="font-display font-medium tracking-wide">STAR JEWELS</div>
              <div className="text-[10px] tracking-[0.28em] uppercase text-sj-gold">Fine fashion jewellery</div>
            </div>
          </div>
          <p className="mt-6 text-sm text-white/70 leading-relaxed max-w-xs">
            {BRAND.tagline} Hand-picked, artisan-crafted pieces designed to celebrate the everyday.
          </p>
          <div className="flex items-center gap-3 mt-6">
            <a href={igUrl} target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="p-3 rounded-full bg-white/10 hover:bg-sj-gold transition-colors" data-testid="footer-instagram">
              <Instagram size={16} />
            </a>
            <a href={`mailto:${BRAND.email}`} aria-label="Email us" className="p-3 rounded-full bg-white/10 hover:bg-sj-gold transition-colors" data-testid="footer-email">
              <Mail size={16} />
            </a>
          </div>
        </div>

        <div>
          <div className="overline text-sj-gold">Shop</div>
          <ul className="mt-5 space-y-3 text-sm text-white/75">
            <li><Link to="/shop" className="hover:text-sj-gold">All Jewellery</Link></li>
            {CATEGORIES.map((c) => (
              <li key={c.key}><Link to={`/shop?category=${c.key}`} className="hover:text-sj-gold">{c.label}</Link></li>
            ))}
            <li><Link to="/return-policy" className="hover:text-sj-gold" data-testid="footer-return-policy">Return &amp; Exchange Policy</Link></li>
            <li><Link to="/terms" className="hover:text-sj-gold" data-testid="footer-terms">Terms &amp; Conditions</Link></li>
            <li><Link to="/privacy" className="hover:text-sj-gold" data-testid="footer-privacy">Privacy Policy</Link></li>
            <li><Link to="/blog" className="hover:text-sj-gold" data-testid="footer-blog">Journal</Link></li>
            <li><Link to="/about" className="hover:text-sj-gold">About</Link></li>
          </ul>
        </div>

        <div>
          <div className="overline text-sj-gold">Reach us</div>
          <ul className="mt-5 space-y-4 text-sm text-white/75">
            <li className="flex gap-3">
              <Instagram size={16} className="mt-0.5 shrink-0" />
              <span>
                Instagram<br />
                <a
                  href={igUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white hover:text-sj-gold transition-colors"
                  data-testid="footer-instagram-handle"
                >
                  @{BRAND.instagram}
                </a>
              </span>
            </li>
            <li className="flex gap-3">
              <Mail size={16} className="mt-0.5 shrink-0" />
              <span>
                Email<br />
                <a href={`mailto:${BRAND.email}`} className="text-white hover:text-sj-gold transition-colors">
                  {BRAND.email}
                </a>
              </span>
            </li>
            <li className="flex gap-3"><MapPin size={16} className="mt-0.5 shrink-0" /> <span>Ships across India</span></li>
          </ul>
        </div>

      </div>

      <div className="border-t border-white/10">
        <div className="mx-auto max-w-[1440px] px-5 sm:px-10 py-5 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-white/50">
          <div>© {new Date().getFullYear()} Star Jewels. All rights reserved.</div>
          <div>Crafted with love in India.</div>
        </div>
      </div>
    </footer>
  );
}
